import "../styles/TestSummary.css";

import { Box, Button, Modal, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import Explanation from "./Explanation";

const TestSummary = ({ data }) => {
	const [activeTab, setActiveTab] = useState("allQuestions");
	const [questions, setQuestions] = useState(data);
	const [open, setOpen] = useState(false);
	const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(null);

	useEffect(() => {
		// Update questions state whenever data prop changes
		setQuestions(data);
	}, [data]);

	useEffect(() => {
		// Filter questions based on active tab
		if (activeTab === "wrongAnswers") {
			const filteredQuestions = data?.filter((row) => row.correctAnswer !== row.yourChoice);
			setQuestions(filteredQuestions);
		} else {
			setQuestions(data);
		}
	}, [activeTab, data]);

	const handleTabChange = (tab) => {
		setActiveTab(tab);
	};

	const handleOpen = (index) => {
		setSelectedQuestionIndex(index);
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
		setSelectedQuestionIndex(null);
	};

	const handleNext = () => {
		if (selectedQuestionIndex !== null && selectedQuestionIndex < questions.length - 1) {
			setSelectedQuestionIndex(selectedQuestionIndex + 1);
		}
	};

	const handlePrevious = () => {
		if (selectedQuestionIndex !== null && selectedQuestionIndex > 0) {
			setSelectedQuestionIndex(selectedQuestionIndex - 1);
		}
	};

	return (
		<div className='test-summary-container'>
			<div className='tabs'>
				<div
					className={`tab ${activeTab === "allQuestions" ? "active" : ""}`}
					onClick={() => handleTabChange("allQuestions")}>
					All Questions
				</div>
				<div
					className={`tab ${activeTab === "wrongAnswers" ? "active" : ""}`}
					onClick={() => handleTabChange("wrongAnswers")}>
					Wrong Answers
				</div>
			</div>
			<div className='tab-content'>
				<table className='test-summary-table'>
					<thead className='test-summary-table-headers'>
						<tr style={{ background: "none" }}>
							<th>Section</th>
							<th>No</th>
							<th>Question Type</th>
							<th>Correct Answer</th>
							<th>Your Choice</th>
							<th>Explanation</th>
						</tr>
					</thead>
					<tbody>
						{questions &&
							questions?.map((row, index) => (
								<tr key={index} className='test-summary-table-row'>
									<td>{row.section}</td>
									<td>{row.no}</td>
									<td>{row.questionType}</td>
									<td>{row.correctAnswer}</td>
									<td
										style={{
											fontWeight: 700,
											color:
												row.correctAnswer === row.yourChoice
													? "#08BD80"
													: "red",
										}}>
										{row.yourChoice}
									</td>
									<td>
										<div
											className='explanation'
											onClick={() => handleOpen(index)}>
											Explanation
										</div>
									</td>
								</tr>
							))}
					</tbody>
				</table>
			</div>
			<Modal
				open={open}
				aria-labelledby='modal-title'
				aria-describedby='modal-description'
				onClose={handleClose}>
				<Box
					sx={{
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						bgcolor: "background.paper",
						boxShadow: 24,
						padding: "1em",
					}}>
					{selectedQuestionIndex !== null && (
						<>
							<Explanation
								data={questions[selectedQuestionIndex]}
								onClose={handleClose}
								onNext={handleNext}
								onBack={handlePrevious}
								currentIndex={selectedQuestionIndex}
								totalQuestions={questions.length}
							/>
							<Box
								sx={{
									display: "flex",
									justifyContent: "space-between",
									mt: 2,
								}}></Box>
						</>
					)}
				</Box>
			</Modal>
		</div>
	);
};

export default TestSummary;
